/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Current status of one known \`Backfill\*\` task, derived from its most recent run.
 * @export
 * @interface BackfillStatus
 */
export interface BackfillStatus {
  /**
   *
   * @type {string}
   * @memberof BackfillStatus
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof BackfillStatus
   */
  status: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof BackfillStatus
   */
  lastStartedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof BackfillStatus
   */
  lastFinishedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof BackfillStatus
   */
  lastError?: string | null;
}

/**
 * Check if a given object implements the BackfillStatus interface.
 */
export function instanceOfBackfillStatus(
  value: object,
): value is BackfillStatus {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function BackfillStatusFromJSON(json: any): BackfillStatus {
  return BackfillStatusFromJSONTyped(json, false);
}

export function BackfillStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackfillStatus {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    status: json["status"],
    lastStartedAt:
      json["lastStartedAt"] == null ? undefined : json["lastStartedAt"],
    lastFinishedAt:
      json["lastFinishedAt"] == null ? undefined : json["lastFinishedAt"],
    lastError: json["lastError"] == null ? undefined : json["lastError"],
  };
}

export function BackfillStatusToJSON(json: any): BackfillStatus {
  return BackfillStatusToJSONTyped(json, false);
}

export function BackfillStatusToJSONTyped(
  value?: BackfillStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    status: value["status"],
    lastStartedAt: value["lastStartedAt"],
    lastFinishedAt: value["lastFinishedAt"],
    lastError: value["lastError"],
  };
}
